import { c as _c } from "react/compiler-runtime";
import NumberFormat from 'react-number-format';
import styled, { css } from 'styled-components';
import Button from '../base/Button';
import Skeleton from '../base/Skeleton';
import Text from '../base/Text';
import { Div } from '../helpers/StyledUtils';
const StyledFooter = styled.div<{
  fill?: boolean;
}>`
  ${({
  theme,
  fill
}) => css`
    ${fill && css`
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 5;
    `}
    display: flex;
    padding: ${theme.spacing(fill ? 3 : 2)} ${theme.spacing(fill ? 6 : 3)};
    border-top: ${theme.border};
    background-color: ${theme.colors.surface.base.surface};
  `}
`;
interface TableFooterProps {
  fill?: boolean;
  current_count?: number;
  total_count?: number | null;
  loading?: boolean;
  pagination?: {
    current_page: number;
    page_size: number;
    entity_name: string;
  };
  onPreviousPage?(): void;
  onNextPage?(): void;
}
const TableFooter: React.FC<TableFooterProps> = t0 => {
  const $ = _c(23);
  const {
    fill,
    current_count,
    total_count,
    loading,
    pagination,
    onPreviousPage,
    onNextPage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      grow: true,
      justify: "space-between"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "center",
      grow: true
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== current_count || $[3] !== loading || $[4] !== pagination || $[5] !== total_count) {
    t3 = <Div flex={t2}>{total_count === null ? <Skeleton w={{
        px: 200
      }} h={{
        px: 20
      }} xsmall={true} /> : <Text as="span" muted={true} shimmering={loading}>{pagination?.current_page && pagination?.page_size && <>Page {pagination.current_page} · {loading ? "Loaded " : "Viewing "}<Text bold={true} as="span"><NumberFormat renderText={_temp} displayType="text" value={current_count ?? pagination.page_size} thousandSeparator="," /></Text>{" "}{pagination.entity_name || "results"}{loading ? "..." : ""}</>}</Text>}</Div>;
    $[2] = current_count;
    $[3] = loading;
    $[4] = pagination;
    $[5] = total_count;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      align: "center",
      gap: 2
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !onPreviousPage || loading;
  const t6 = onPreviousPage ? onPreviousPage : undefined;
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <Button icon="chevron_left" outline={true} disabled={t5} onClick={t6} />;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = !onNextPage || loading;
  const t9 = onNextPage ? onNextPage : undefined;
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <Button icon="chevron_right" outline={true} disabled={t8} onClick={t9} />;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t7) {
    t11 = <Div flex={t4}>{t7}{t10}</Div>;
    $[14] = t10;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t3) {
    t12 = <Div flex={t1}>{t3}{t11}</Div>;
    $[17] = t11;
    $[18] = t3;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== fill || $[21] !== t12) {
    t13 = <StyledFooter fill={fill}>{t12}</StyledFooter>;
    $[20] = fill;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};
export default TableFooter;
function _temp(v) {
  return v;
}